import React from "react";
import ReactDOM from "react-dom";
import { TechVideosModel } from "../models/TechVideosModel";
import { ContentTechVideoImagePath } from "../utils/ContentMediaPath";
import debounce from "lodash/debounce";

interface TechVideosProps {
  content: any;
}

interface TechVideosState {
  currentIndex: number;
  check: boolean;
  ready: boolean;
}

class TechVideos extends React.Component<TechVideosProps, TechVideosState> {
  triggerPos: number = null;

  get current(): TechVideosModel {
    return this.props.content[this.state.currentIndex];
  }

  get isFirstPage(): boolean {
    return !!(this.state.currentIndex === 0);
  }

  get isLastPage(): boolean {
    return !!(this.state.currentIndex >= this.props.content.length - 1);
  }

  get videoEl(): any {
    return document.getElementById("techVideo");
  }

  constructor(props: TechVideosProps) {
    super(props);

    this.state = {
      currentIndex: 0,
      check: false,
      ready: false,
    };
  }

  componentDidMount(): void {
    window.addEventListener(
      "scroll",
      debounce(() => this.tick(), 10)
    );
    window.addEventListener("load", () => {
      const wrap = document.getElementById("technology");
      if (!wrap) return;

      this.triggerPos = wrap.offsetTop;
      this.setState({ check: true });
    });
  }

  tick() {
    if (!this.state.check || this.state.ready) return;
    const scrollPos: number = window.pageYOffset;

    if (scrollPos >= this.triggerPos) {
      this.setState({ check: false, ready: true });
    }
  }

  setCurrentIndex(currentIndex: number) {
    this.setState({ currentIndex });
  }

  prev(): void {
    if (this.isFirstPage) return;
    const currentIndex = this.state.currentIndex - 1;
    this.setState({ currentIndex });
    if (this.videoEl) this.videoEl.play();
  }

  next(): void {
    if (this.isLastPage) return;
    const currentIndex = this.state.currentIndex + 1;
    this.setState({ currentIndex });
    if (this.videoEl) this.videoEl.play();
  }

  handleClick(e) {
    if (e.target.pause) e.target.play();
    return true;
  }

  render() {
    if (!this.props.content.length) {
      return <div />;
    }

    return (
      <div>
        <div className="techVideos__videoWrap">
          {this.state.ready ? (
            <video
              id="techVideo"
              className="techVideos__video"
              controls={false}
              autoPlay={true}
              loop={true}
              preload="auto"
              src={this.current.video}
              onClick={this.handleClick}
            />
          ) : null}
        </div>

        <div className="techVideos__content">
          <div className="techVideos__items">
            {this.props.content.map((videoItem: TechVideosModel, i: number) => {
              return (
                <div
                  className={`techVideos__item ${
                    i === this.state.currentIndex
                      ? "techVideos__item--active"
                      : ""
                  }`}
                  key={`techVideo__${i}`}
                  onClick={() => this.setCurrentIndex(i)}
                >
                  <div className="techVideos__itemTitle">
                    {videoItem.name}
                    {videoItem.name === "EYESIGHT® DRIVER ASSIST SYSTEM" && (
                      <span className="tt">
                        *
                        <span className="tt__content">
                          Standard on Subaru XV 2.0i-L, 2.0i Premium and 2.0i-S
                        </span>
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <nav className="techVideos__controls">
            <div
              className={`techVideos__control techVideos__control--prev ${
                this.isFirstPage ? "techVideos__control--disabled" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                this.prev();
              }}
            />
            <div
              className={`techVideos__control techVideos__control--next ${
                this.isLastPage ? "techVideos__control--disabled" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                this.next();
              }}
            />
          </nav>

          <div
            className="techVideos__text"
            dangerouslySetInnerHTML={{ __html: this.current.text }}
          />
        </div>
      </div>
    );
  }
}

export default TechVideos;
